import { render, staticRenderFns } from "./A_activated.vue?vue&type=template&id=d1139b9e&scoped=true&"
import script from "./A_activated.vue?vue&type=script&lang=js&"
export * from "./A_activated.vue?vue&type=script&lang=js&"
import style0 from "./A_activated.vue?vue&type=style&index=0&id=d1139b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1139b9e",
  null
  
)

export default component.exports